// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"bac762ff","693":"be88f81e"}[chunkId] + ".chunk.js";
};